import { FollowUpType } from "models/appointment";
import {
    isScreeningFlow,
    ScreeningFlow,
    SCREENING_FLOW,
} from "models/screening-flow";
import { AppointmentHold } from "./types";

const USES_PRIVATE_LAB_KEY = "usesPrivateLab";
const BOOKING_FOLLOW_UP_TYPE_KEY = "bookingFollowUpType";
const APPOINTMENT_HOLD_KEY = "appointmentHold";
const SCREENING_FLOW_KEY = "screeningFlow";
const IS_ENGAGE_APPOINTMENT_KEY = "isEngageAppointment";

export const setPreSelectedLabType = (usesPrivateLab: boolean): void => {
    sessionStorage.setItem(
        USES_PRIVATE_LAB_KEY,
        JSON.stringify(usesPrivateLab)
    );
};

export const getPreSelectedLabType = (): boolean => {
    const usesPrivateLab = sessionStorage.getItem(USES_PRIVATE_LAB_KEY);
    return usesPrivateLab ? JSON.parse(usesPrivateLab) : false;
};

export const hasPreSelectedLabType = (): boolean =>
    sessionStorage.getItem(USES_PRIVATE_LAB_KEY) !== null;

/** `undefined` when the user has not chosen a lab type yet. */
export const getBookingFlowLabType = (): "public" | "private" | undefined => {
    if (!hasPreSelectedLabType()) {
        return undefined;
    }
    return getPreSelectedLabType() ? "private" : "public";
};

export const removePreSelectedLabType = (): void => {
    sessionStorage.removeItem(USES_PRIVATE_LAB_KEY);
};

export const setAppointmentHold = (
    clinicId: number,
    datetime: string,
    clinicName?: string
): void => {
    const appointmentHold = {
        clinicId,
        datetime,
        clinicName,
    };
    sessionStorage.setItem(
        APPOINTMENT_HOLD_KEY,
        JSON.stringify(appointmentHold)
    );
};

export const getAppointmentHold = (): AppointmentHold | null => {
    const appointmentHold = sessionStorage.getItem(APPOINTMENT_HOLD_KEY);
    return appointmentHold ? JSON.parse(appointmentHold) : null;
};

export const removeAppointmentHold = (): void => {
    sessionStorage.removeItem(APPOINTMENT_HOLD_KEY);
};

export const setScreeningFlow = (screeningFlow: ScreeningFlow): void => {
    sessionStorage.setItem(SCREENING_FLOW_KEY, screeningFlow);
};

export const getScreeningFlow = (): ScreeningFlow => {
    const screeningFlow = sessionStorage.getItem(SCREENING_FLOW_KEY);

    return isScreeningFlow(screeningFlow) ? screeningFlow : SCREENING_FLOW.STI;
};

export const hasScreeningFlow = (): boolean =>
    isScreeningFlow(sessionStorage.getItem(SCREENING_FLOW_KEY));

export const removeScreeningFlow = (): void => {
    sessionStorage.removeItem(SCREENING_FLOW_KEY);
};

export const setIsEngageAppointment = (isEngageAppointment: boolean): void => {
    sessionStorage.setItem(
        IS_ENGAGE_APPOINTMENT_KEY,
        JSON.stringify(isEngageAppointment)
    );
};

export const getIsEngageAppointment = (): boolean => {
    const isEngageAppointment = sessionStorage.getItem(
        IS_ENGAGE_APPOINTMENT_KEY
    );
    return isEngageAppointment ? JSON.parse(isEngageAppointment) : false;
};

export const removeIsEngageAppointment = (): void => {
    sessionStorage.removeItem(IS_ENGAGE_APPOINTMENT_KEY);
};

const isFollowUpType = (value: string | null): value is FollowUpType =>
    value === FollowUpType.Regular || value === FollowUpType.Express;

export const setBookingFollowUpType = (followUpType: FollowUpType): void => {
    sessionStorage.setItem(BOOKING_FOLLOW_UP_TYPE_KEY, followUpType);
};

export const getBookingFollowUpType = (): FollowUpType | null => {
    const followUpType = sessionStorage.getItem(BOOKING_FOLLOW_UP_TYPE_KEY);
    return isFollowUpType(followUpType) ? followUpType : null;
};

export const removeBookingFollowUpType = (): void => {
    sessionStorage.removeItem(BOOKING_FOLLOW_UP_TYPE_KEY);
};
